import { listTrain,trainInfo,add,policy,filex,aliyuncs,menuList } from '@/api/train'
  
const actions = {
    listTrain(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            listTrain(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    trainInfo(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            trainInfo(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    add(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            add(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    policy(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            policy(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    filex(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            filex(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    aliyuncs(state, info) {
        const infoData = info
        console.log("aliyuncs--------------------");
        console.log(infoData);
        return new Promise((resolve,reject) => {
            aliyuncs(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    menuList(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            menuList(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
   
    

}

export default {
  namespaced: true,
  actions
}
